import type { ICheckTicketResponse, IUser } from '@/types/auth';

import HTTP from '@/utils/http';

export const AuthAPI = {
  whoAmI: () => HTTP.get<IUser>('auth/whoami'),
  checkTicket: (ticket: string) => HTTP.post<ICheckTicketResponse>('auth/login', { ticket }),
  logout: () => HTTP.post('auth/logout'),
};
